import * as angular from 'angular';
import controller from './btnarray.controller';
import template from './btnarray.directive.tpl.html';

var btnArray = function() {
    return {
        restrict: 'E',
        template: template,
        replace: true,
        controller: 'btnArrayCtrl',
        controllerAs: 'vm',
        bindToController: true,
        scope: {
            options: '='
        },
        link: function ($scope: any, el: any, attrs: any) {
            $scope.$watch('options', function (newVal: any) {
              // do nothing
            }, true);
        }
    };
};

export default angular.module('aps.directive.btnarray', [controller])
    .directive('btnArray', btnArray)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/dashboard/btnArray.directive.ts